<template>
    <section class="d-flex flex-column h-full">
         <TopAppBarDrawer
        :isDrawerOpen="isDrawerOpen"
        @closeDrawer="closeDrawer"
      ></TopAppBarDrawer>
       <div class="sm_header">
       
        <button class="menu_btn" @click="openDrawer()">
          <span>mobile menu</span>
        </button>
         <h1 >{{ $t("995") }}</h1> 
       </div> 
        <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
        >
        </TopAppBar>
        <div class="flex-grow-1 scroll-y">
            <component :is="isListType"></component>
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
    </section>
</template>

<script>
/**
 * 단독시험 메인 컴포넌트(independent exam main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import TopAppBarDrawer from '@/components/TopAppBarDrawer.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'

export default {  
    name: 'exam',
    components: {
        'total': () => import('@/components/independentExam/list/Total.vue'),
        'my': () => import('@/components/independentExam/list/My.vue'),
        'result': () => import('@/components/independentExam/list/Result.vue'),
        'category': () => import('@/components/independentExam/list/Category.vue'),
        TopAppBar,
        TopAppBarDrawer,
    },

    data() {
        return {
            listType: 'total',
            isDrawerOpen: false,       
        }
    },
    
    mixins: [topAppBarMixin],
    computed: {
        isListType() {
            return this.$route.query.listType || 'my'
        }
    },
    mounted() {
        // set header title
        this.setTopAppBarBackSearch(this.$t('995'))

        const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
            let ripple = new MDCRipple.attachTo(el)
            return ripple
        })
    },

    methods: {
        changeMode(mode) {
            this.listType = mode
        },
           // Open drawer
        openDrawer() {
            this.isDrawerOpen = true;
        },
         // Close drawer
        closeDrawer() {
        this.isDrawerOpen = false;
        },
    }
}
</script>


<style scoped>
.sm_header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 55px;
  z-index: 4;
  background-color: #fff;
  border: none;
  box-shadow: none;
}
.sm_header h1 {
  text-align: center;
  color: #212121;
  font-size: 1.25rem;
  font-weight: 500;
  height: 55px;
  line-height: 55px;
  margin-top: 0px;
}
.sm_header .menu_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
}
.sm_header .menu_btn span {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  font-size: 0;
  display: inline-block;
}
.sm_header .menu_btn:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: -5px;
}
.sm_header .menu_btn:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: 5px;
}
.sm_header .search_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/search_btn.svg) center center no-repeat;
  background-size: 22px auto;
}

</style>
